module.exports = __webpack_public_path__ + "static/media/crm_temp_sent.727cf9a7.svg";